"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewMaturityDateType = void 0;
var NewMaturityDateType;
(function (NewMaturityDateType) {
    NewMaturityDateType["accountMaturityDate"] = "accountMaturityDate";
    NewMaturityDateType["specificMaturityDate"] = "specificMaturityDate";
    NewMaturityDateType["specificTermInMonths"] = "specificTermInMonths";
})(NewMaturityDateType || (exports.NewMaturityDateType = NewMaturityDateType = {}));
